/**
 * List Schema of ResponsavelAssociado
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ResponsavelAssociado} from '@/model/resource/ResponsavelAssociado'

/* TODO: review generated schema */
export class ListResponsavelAssociadoSchema extends Schema {
  readonly name = 'ListResponsavelAssociado'

  readonly fieldSet: FieldSet<ResponsavelAssociado> = {
    idAssociadoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    razaoSocial: (): FieldComponent => ({
      is: Component.Render,
    }),
    nomeFantasia: (): FieldComponent => ({
      is: Component.Render,
    }),
    cnpj: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.cnpj(schema.model.cnpj),
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
